import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Breadcrumb, BreadcrumbItem, Container } from "reactstrap";
import "./BuyPoints.scss";
import { chargeCustomer1 } from "../../services/buyPoints.services";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { hideLoader, showLoader } from "../../utils/action/Action";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import IField, { CARD_TYPE, CVV_TYPE } from "@cardknox/react-ifields";
import { IoArrowForwardOutline } from "react-icons/io5";

function BuyPointsFunctionality({
  data,
  onClose,
  getPoints,
  // onPurchaseSuccess,
}) {
  // let location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  // console.log("Pointsssss", getPoints);

  const [cardToken, setCardToken] = useState("");
  const [cvvToken, setCvvToken] = useState("");

  const cardRef = useRef();
  const cvvRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [cardData, setCardData] = useState({
    mmyy: "",
    name: "",
    zip: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCardData((prev) => ({
      ...prev,
      [name]: value,
    }));

    validateInput(name, value);
  };

  const validateInput = (name, value) => {
    let errorMsg = "";

    switch (name) {
      case "cardNum":
        if (!/^\d{16}$/.test(value)) {
          errorMsg = "Card number must be 16 digits.";
        }
        break;
      case "mmyy":
        if (name === "mmyy") {
          if (!/^\d{4}$/.test(value)) {
            errorMsg = "Enter a valid MMYY format (e.g., 0525).";
          } else {
            const month = parseInt(value.slice(0, 2), 10);
            const year = parseInt(value.slice(2), 10);

            if (month < 1 || month > 12) {
              errorMsg = "Month must be between 01 and 12.";
            } else {
              const currentYear = new Date().getFullYear() % 100;
              if (year < currentYear) {
                errorMsg = "Year must not be in the past.";
              }
            }
          }
        }
        break;
      case "cvv":
        if (value.length < 3 || value.length > 4) {
          errorMsg = "CVV must be 3 or 4 digits.";
        }
        break;
      case "name":
        if (value.length < 3 || value === "") {
          errorMsg = "Please eneter your full name";
        }
        break;
      case "zip":
        if (value.length < 5 || value.length > 6) {
          errorMsg = "Zip value must be 5 or 6 digits.";
        }
        break;
      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMsg,
    }));
  };

  const handleGetTokens = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;

    if (!cardData.mmyy || !cardData.name || !cardData.zip) {
      return setErrors((prev) => ({
        ...prev,
        mmyy: "Enter a valid MMYY format (e.g., 0525).",
        name: "Please eneter your full name",
        zip: "Zip value must be 5 or 6 digits.",
      }));
    }

    setIsSubmitting(true);
    dispatch(showLoader());

    cvvRef.current.getToken();
    cardRef.current.getToken();
  };

  const handleCardSubmit = async () => {
    if (data?.isUserLoggedIn) {
      dispatch(showLoader());

      let request = {
        // xCommand: "cc:sale",
        // xCardnum: cardToken,
        // xBillFirstName: cardData.name,
        // xBillZip: cardData.zip,
        // xExp: cardData.mmyy,
        // xCvv: cvvToken,

        CustomerName: cardData.name,
        CardNum: cardToken,
        ExpDate: `${cardData.mmyy.slice(0, 2)}/${cardData.mmyy.slice(2)}`,
        CVV: cvvToken,
        // Amount: location?.state?.data,
        Amount: data.amount,
        Reference: "INV-002",
      };

      const purchaseTypeList =
        data.amount === "20.00" ? "Points_100_20" : "Points_1000_100";

      // console.log("ppppprrrrrrrrrru", purchaseTypeList);
      // console.log("ppppprrrrrrrrrru2 isUserLogged In", data.isUserLoggedIn);
      // console.log("ppppprrrrrrrrrru3 amount", data.amount);

      try {
        const response = await chargeCustomer1(request, {
          userName,
          purchaseTypeList,
        });

        // console.log("Payment Response:", response);

        if (response?.status === 200) {
          if (response?.data?.error) {
            toast.warn("Credit Purchase Failed!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });

            setTimeout(() => {
              if (onClose) onClose();
            }, 1500);
          } else {
            toast.success("Credits Purchased Successfully!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });

            // if (typeof onPurchaseSuccess === "function") {
            //   onPurchaseSuccess();
            // }

            setTimeout(() => {
              if (onClose) onClose();
            }, 1500);
          }

          dispatch(hideLoader());
          getPoints();
          // console.log("Successssssss");

          navigate("/");
        } else {
          toast.warn("Please try again!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });

          setTimeout(() => {
            if (onClose) onClose();
          }, 1500);

          dispatch(hideLoader());
          navigate("/points");
        }
      } catch (error) {
        console.error("Erroreeee:", error);
        toast.warn("Please try again! ", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });

        setTimeout(() => {
          if (onClose) onClose();
        }, 1500);

        dispatch(hideLoader());
        navigate("/points");
      } finally {
        dispatch(hideLoader());
        setIsSubmitting(false);
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to buy credits?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }

    setCardToken("");
    setCvvToken("");
  };

  const cardKnoxAccountConfig = {
    xKey: process.env.REACT_APP_CRADKNOXKEY,
    xSoftwareVersion: "0.1.0",
    xSoftwareName: "Nesiyatova",
  };

  const cardKnoxInputStyles = {
    width: "80%",
    color: "black",
    display: "block",
    padding: "15px 14px 15px 24px",
    fontSize: "1rem",
    fontWeight: 400,
    // lineHeight: 1.5,
    appearance: "none",
    background: "#F9FAFB",
    border: "1px solid #E5E7EB",
    borderRadius: "5px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  };
  const cardKnoxCvvInputStyles = {
    width: "80%",
    overflow: "hidden",
    color: "black",
    display: "block",
    padding: "15px 14px 15px 24px",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
    appearance: "none",
    background: "#F9FAFB",
    border: "1px solid #E5E7EB",
    borderRadius: "5px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  };

  const onCardToken = (token) => {
    if (token.xToken) {
      setCardToken(token.xToken);
      setErrors((prev) => ({ ...prev, card: "" }));
    } else {
      setErrors((prev) => ({
        ...prev,
        card: "Please make sure you have added right card details",
      }));
    }
  };

  const onCvvToken = (token) => {
    if (token.xToken) {
      setCvvToken(token.xToken);
      setErrors((prev) => ({ ...prev, cvv: "" }));
    } else {
      setErrors((prev) => ({
        ...prev,
        cvv: "Please make sure you have added right cvv details",
      }));
    }
  };

  useEffect(() => {
    if (cardToken && cvvToken) {
      console.log("UseEffect  Called");

      handleCardSubmit();

      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardToken, cvvToken]);

  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName
  );
  // let key;
  // if (process.env.REACT_APP_ENV === "staging") {
  //   key = "_3V8Lao9sHN4k0lx9xFQ90f76y38X87oH052w18ELp";
  // } else if (process.env.REACT_APP_ENV === "production") {
  //   key = "Lx8n2y5tp7d6W676zDeSQ6WHHPqVv6R4c9z0g48akV "; // Replace with your live script URL
  // }

  // let client = new window.usaepay.Client(
  //   key
  // );

  // let paymentCard = client.createPaymentCardEntry();

  // paymentCard.addHTML("paymentCardContainer");

  // const styles = {
  //   "#container": {
  //     "background-color": "gray",
  //     height: "300px",
  //     width: "300px",
  //   },
  //   container: {
  //     "background-color": "gray",
  //     height: "300px",
  //     width: "300px",
  //   },
  //   "input-icon": {
  //     //height: "100px !important",
  //     width: "100px !important",
  //     padding: "0 !important",
  //     height: "auto !important",
  //   },
  //   base: {
  //     height: "50px",
  //     width: "50px",
  //     padding: "0 15px",
  //     margin: "0 15px",
  //     border: "1px solid #c5c5c5 !important",
  //   },
  // };

  // paymentCard.generateHTML(styles);

  // paymentCard.addHTML("paymentCardContainer");

  // paymentCard.addEventListener("error", (errorMessage) => {
  //   let errorContainer = document.getElementById("paymentCardErrorContainer");
  //   errorContainer.textContent = errorMessage;
  // });

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (isUserLoggedIn) {
  //     // create a payment key, returns a promise which will resolve in an error or the payment key
  //     await client
  //       .getPaymentKey(paymentCard)
  //       .then(async (result) => {
  //         console.log(result);
  //         if (result.error) {
  //           let errorContainer = document.getElementById(
  //             "paymentCardErrorContainer"
  //           );
  //           errorContainer.textContent = result.error.message;
  //         } else {
  //           try {
  //             dispatch(showLoader());
  //             const requestBody = {
  //               command: "cc:sale",
  //               payment_key: result,
  //               invoice: "",
  //               ponum: "",
  //               description: "",
  //               comments: "",
  //               email: "",
  //               sendReceipt: "",
  //               ignoreDuplicate: "",
  //               mercheMailAddr: "",
  //               amount: location?.state?.data,
  //               amountDtail: {
  //                 subtotal: "",
  //                 tax: "",
  //                 tip: "",
  //                 discount: "",
  //                 shipping: "",
  //               },
  //               traits: {
  //                 isDebt: "",
  //                 isBillPay: "",
  //                 isRecurring: "",
  //                 isHealthcare: "",
  //                 isCashAdvance: "",
  //               },
  //               custKey: "",
  //               billingAddress: {
  //                 firstName: "",
  //                 lastName: "",
  //                 street: "",
  //                 street2: "",
  //                 city: "",
  //                 state: "",
  //                 postalcode: "",
  //                 country: "",
  //                 phone: "",
  //                 fax: "",
  //               },
  //               shippingAddress: {
  //                 firstName: "",
  //                 lastName: "",
  //                 street: "",
  //                 city: "",
  //                 state: "",
  //                 postalCode: "",
  //                 country: "",
  //                 phone: "",
  //               },
  //               lineItemsItems: [
  //                 {
  //                   productKey: "",
  //                   name: "",
  //                   cost: "",
  //                   qty: "",
  //                   taxAmount: "",
  //                   locationKey: "",
  //                   listPrice: "",
  //                 },
  //               ],
  //               customFields: {
  //                 customFields1: "",
  //                 customFields2: "",
  //               },
  //             };
  //             const purchaseTypeList =
  //               location?.state?.data === "20.00"
  //                 ? "Points_100_20"
  //                 : "Points_1000_100";
  //             const response = await chargeCustomer(requestBody, {
  //               userName: userName,
  //               purchaseTypeList: purchaseTypeList,
  //             });
  //             if (response?.status === 200) {
  //               if (response?.data?.error === true) {
  //                 toast.warn("Credit Purchase Failed!", {
  //                   position: toast.POSITION.TOP_RIGHT,
  //                   autoClose: 2000,
  //                 });
  //               } else {
  //                 dispatch(hideLoader());
  //                 toast.success("Credits Purchased Successfully!", {
  //                   position: toast.POSITION.TOP_RIGHT,
  //                   autoClose: 2000,
  //                 });
  //               }
  //               getPoints();
  //               navigate("/points");
  //             } else {
  //               toast.warn("Please try again!", {
  //                 position: toast.POSITION.TOP_RIGHT,
  //                 autoClose: 2000,
  //               });
  //               dispatch(hideLoader());
  //               navigate("/points");
  //             }
  //           } catch {
  //             dispatch(hideLoader());
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err.message);
  //       });
  //   } else {
  //     const notLoggedIn = await swal({
  //       title: "Please Continue to Log In",
  //       text: "You want to buy credits?",
  //       icon: "warning",
  //       buttons: ["Cancel", "Log In"],
  //     });
  //     if (notLoggedIn) {
  //       navigate("/sign-in");
  //     }
  //   }
  // };

  return (
    <div className="nt-main_section buyPoints">
      {/* <Container> */}
      {/* <div className="breadcrumb_section">
        <Container>
          <Breadcrumb className="breadcrumb">
            <BreadcrumbItem>
              <Link to="/" className="breadcrumb_item1">
                Home
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/points" className="breadcrumb_item1">
                My Credits
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <Link to="#" className="breadcrumb_item2">
                Buy Credits
              </Link>
            </BreadcrumbItem>
          </Breadcrumb>
        </Container>
      </div> */}
      <div className="buyPoints_section">
        {/* <Container fluid> */}
        <div className="buyPoints_section_box">
          <div className="buyPoints_section_header">
            <h1>Buy Credits</h1>
          </div>
          {/* <form
              id="paymentForm"
              action="https://sandbox.usaepay.com/gate.php"
              method="POST"
              onSubmit={handleSubmit}
            > */}

          {/* <input
                type="hidden"
                name="UMkey"
                value="_l11R7ARXr37M6egkr51Eh7zKA5I4Je7"
              /> */}

          {/* <label htmlFor="paymentCardContainer">Credit/Debit Card</label> */}
          {/* <h4>Amount ${location?.state?.data}</h4> */}

          {/* <input type="hidden" name="UMredir" value="http://localhost:3000/buyPoints" /> */}
          {/* <div id="paymentCardContainer"></div>
              <div id="paymentCardErrorContainer" role="alert"></div> */}
          {/*create fields for name on card and zip code */}
          {/* <div className="form-group">
                <input
                  type="text"
                  className="form-control noc22"
                  id="nameOnCard"
                  name="UMname"
                  placeholder="Name on Card"
                  required
                />

                <input
                  type="text"
                  className="form-control zip22"
                  id="zipCode"
                  name="UMzip"
                  placeholder="Zip Code"
                  required
                />
              </div>

              <Button type="submit" className="submit_btn">
                Submit
              </Button>
            </form> */}

          <form onSubmit={handleGetTokens} className="card-form">
            {/* Card Holder Name */}
            <div className="form-group form-group-wide">
              <label className="form-label">Card Holder Name:</label>
              <input
                onChange={handleChange}
                value={cardData.name}
                placeholder="Write Name"
                type="text"
                name="name"
                id="name"
                className="form-input"
              />
              {errors.name && <span className="form-error">{errors.name}</span>}
            </div>

            <div className="zip_and_card">
              {/* Card Number */}
              <div className="form-group form-group-wide">
                <label className="form-label">Card Number:</label>
                <IField
                  type={CARD_TYPE}
                  account={cardKnoxAccountConfig}
                  options={{
                    autoFormat: true,
                    autoFormatSeparator: " ",
                    placeholder: "0000 0000 0000 0000",
                    className: "my-custom-card-input",
                    iFieldstyle: cardKnoxInputStyles,
                  }}
                  onToken={onCardToken}
                  ref={cardRef}
                />
                {errors.card && (
                  <span className="form-error">{errors.card}</span>
                )}
              </div>

              {/* Zip */}
              <div className="form-group">
                <label className="form-label">Zip:</label>
                <input
                  onChange={handleChange}
                  value={cardData.zip}
                  type="text"
                  placeholder="000"
                  name="zip"
                  id="zip"
                  maxLength={6}
                  className="form-input"
                />
                {errors.zip && <span className="form-error">{errors.zip}</span>}
              </div>
            </div>

            <div className="exp_and_cvv">
              {/* Expiration */}
              <div className="form-group">
                <label className="form-label">Expiration Date:</label>
                <input
                  onChange={handleChange}
                  value={cardData.mmyy}
                  type="text"
                  placeholder="MM/YY"
                  name="mmyy"
                  id="mmyy"
                  maxLength={4}
                  className="form-input"
                />
                {errors.mmyy && (
                  <span className="form-error">{errors.mmyy}</span>
                )}
              </div>

              {/* CVV */}
              <div className="form-group">
                <label className="form-label">CVV:</label>
                <IField
                  type={CVV_TYPE}
                  account={cardKnoxAccountConfig}
                  options={{
                    autoFormat: true,
                    autoFormatSeparator: " ",
                    placeholder: "CVV",
                    iFieldstyle: cardKnoxCvvInputStyles,
                  }}
                  onToken={onCvvToken}
                  ref={cvvRef}
                />
                {errors.cvv && <span className="form-error">{errors.cvv}</span>}
              </div>
            </div>

            <button type="submit" className="submit-btn">
              Submit <IoArrowForwardOutline />
            </button>
          </form>

          {/* <form onSubmit={handleCardSubmit}>
              <div className="row">
                <div className="col-md-12 mt-2">
                  <label htmlFor="cardNum">Card No</label>
                  <input className="form-control" type="text" name="cardNum" id="cardNum" maxLength={16} value={cardData.cardNum} onChange={handleChange}/>
                  {errors.cardNum && <span className="error">{errors.cardNum}</span>}
                </div>

                <div className="col-md-4 mt-2">
                  <label htmlFor="month">Month</label>
                  <input className="form-control" type="text" name="month" id="month" maxLength={2} value={cardData.month} onChange={handleChange} />
                  {errors.month && <span className="error">{errors.month}</span>}
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="year">Year</label>
                  <input className="form-control" type="text" name="year" id="year" maxLength={4} value={cardData.year} onChange={handleChange} />
                  {errors.year && <span className="error">{errors.year}</span>}
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="cvv">CVV</label>
                  <input className="form-control" type="text" name="cvv" id="cvv" maxLength={4} value={cardData.cvv} onChange={handleChange} />
                  {errors.cvv && <span className="error">{errors.cvv}</span>}
                </div>
                <div className="col-md-8 mt-2">
                  <label htmlFor="name">Name</label>
                  <input className="form-control" type="text" name="name" id="name" value={cardData.name} onChange={handleChange} />
                  {errors.name && <span className="error">{errors.name}</span>}
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="zip">zip</label>
                  <input className="form-control" type="text" name="zip" id="zip" maxLength={6} value={cardData.zip} onChange={handleChange} />
                  {errors.zip && <span className="error">{errors.zip}</span>}
                </div>
              </div>
              <button className="btn submit_btn" type="submit">Submit</button>
            </form> */}
        </div>
        {/* </Container> */}
      </div>
      {/* </Container> */}
    </div>
  );
}

export default BuyPointsFunctionality;
